/**
 * Turn free text into a safe FTS5 query. Every whitespace-separated term becomes a quoted
 * phrase with prefix matching (`"term"*`), so operators (`AND`, `NOT`, `NEAR`), parentheses,
 * colons and stray quotes are literal text and never a syntax error. Terms without a letter
 * or digit produce no tokens and are dropped. Returns undefined when nothing is searchable.
 */
export function toFtsQuery(input: string): string | undefined {
  const terms = input
    .split(/\s+/u)
    .map((t) => t.replace(/"/gu, ""))
    .filter((t) => /[\p{L}\p{N}]/u.test(t))
    .map((t) => `"${t}"*`);
  return terms.length === 0 ? undefined : terms.join(" ");
}
